import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    toggleEmailTemplate: configurationServices.toggleMerchantEmailTemplate,
    deleteEmailTemplate: configurationServices.deleteMerchantEmailTemplate,
    duplicateEmailTemplate: configurationServices.duplicateMerchantEmailTemplate,
    editEmailTemplatesDisplay: configurationServices.editMerchantEmailTemplatesDisplay,
  },
  [configurationTypes.returnsPortal]: {
    toggleEmailTemplate: configurationServices.togglePortalEmailTemplate,
    deleteEmailTemplate: configurationServices.deletePortalEmailTemplate,
    duplicateEmailTemplate: configurationServices.duplicatePortalEmailTemplate,
    editEmailTemplatesDisplay: configurationServices.editPortalEmailTemplatesDisplay,
  },
}
